import { connect } from 'react-redux';

import { selectors as instanceSelectors } from 'dux/createInstance';
import { actionCreators, selectors as orgSelectors } from 'dux/org';
import { selectors as userSelectors } from 'dux/user';

import BillingPage from './BillingPage';

const mapStateToProps = (state) => ({
  getOrgState: orgSelectors.getOrgState(state).trialCreditCents,
  price: instanceSelectors.getCreateInstanceState(state).price,
  isBillingUser: userSelectors.isBillingUser(state),
});

const mapDispatchToProps = {
  completeBillingSetup: actionCreators.completeBillingSetup,
  getOrg: actionCreators.getOrg,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingPage);
